import { useEffect, useState } from 'react';

type UseInputValueProps = {
  initialValue?: string;
};
export const useInputValue = ({ initialValue }: UseInputValueProps) => {
  const [inputValue, setInputValue] = useState(initialValue ?? '');

  useEffect(() => {
    setInputValue(initialValue ?? '');
  }, [initialValue]);

  return { inputValue, setInputValue };
};
